// extracted by mini-css-extract-plugin
export default {"product-list":"styles_product-list__OmYlD","shipment":"styles_shipment__KjDpA"};